/* v18.3 — reveal on scroll, counting numbers, marquee, photo strip */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal */
  var targets = document.querySelectorAll('.section-head, .card, .hoProgCard, .statsband-item, .hoSpecWrap, .hoTableWrap, .hoRoute li, .supply-step, .hoWhy li, .hoBuy li, .faq-item, .hoLoc .place, .hoStrip figure, .hero-stat, .hoCompliance div');
  var i = 0;
  targets.forEach(function(el){ el.classList.add('rv'); el.classList.add('rv-d' + ((i++ % 4) + 1)); });
  var hero = document.querySelector('.hero');
  if (!('IntersectionObserver' in window) || reduce) {
    targets.forEach(function(el){ el.classList.add('in'); });
    if (hero) hero.classList.add('in');
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function(el){ io.observe(el); });
    if (hero) setTimeout(function(){ hero.classList.add('in'); }, 120);
  }

  /* count-up: "1,092t" -> animates 0 → 1092, keeps the unit */
  function countUp(el){
    var raw = el.textContent.trim();
    var m = raw.match(/^([^\d]*)([\d,.]+)(.*)$/);
    if (!m) return;
    var num = parseFloat(m[2].replace(/,/g,'')); if (isNaN(num)) return;
    var dec = (m[2].split('.')[1] || '').length;
    var useComma = m[2].indexOf(',') > -1;
    var start = null, dur = 1400;
    function fmt(v){ var s = v.toFixed(dec); if (useComma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return s; }
    function step(ts){
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur); p = 1 - Math.pow(1 - p, 3);
      el.innerHTML = m[1] + fmt(num * p) + '<span class="u">' + m[3] + '</span>';
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var nums = document.querySelectorAll('.statsband-num, .hero-stat-num');
  if (!reduce && 'IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { countUp(e.target); io2.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function(el){ io2.observe(el); });
  }

  /* marquee: duplicate the list so it loops */
  document.querySelectorAll('.hoCerts ul').forEach(function(ul){
    if (ul.dataset.dup) return; ul.dataset.dup = '1';
    var wrap = document.createElement('div'); wrap.className = 'marquee';
    ul.parentNode.insertBefore(wrap, ul); wrap.appendChild(ul);
    ul.innerHTML += ul.innerHTML;
  });

  /* photo strip: drag to scroll + arrows */
  document.querySelectorAll('.hoStrip').forEach(function(s){
    var t = s.querySelector('.track'); if (!t) return;
    var down = false, sx = 0, sl = 0;
    t.addEventListener('pointerdown', function(e){ down = true; sx = e.pageX; sl = t.scrollLeft; t.classList.add('drag'); });
    window.addEventListener('pointerup', function(){ down = false; t.classList.remove('drag'); });
    t.addEventListener('pointermove', function(e){ if (!down) return; t.scrollLeft = sl - (e.pageX - sx); });
    var step = function(){ var f = t.querySelector('figure'); return f ? f.getBoundingClientRect().width + 14 : 320; };
    var prev = s.querySelector('[data-prev]'), next = s.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function(){ t.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function(){ t.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();
